/* unplugin-vue-components disabled */import { nextTick } from 'vue';
var noMarginClassName = 'i-layout-content-main-no-margin';
var noCopyrightClassName = 'i-copyright-hidden';
var contextFlexClassName = 'i-layout-content-flex';
var contextMainFlexClassName = 'i-layout-content-main-flex';
export default {
  name: 'i-frame',
  props: {
    src: {
      type: String,
      default: ''
    },
    // 是否保留默认左右边距（24px）
    margin: {
      type: Boolean,
      default: false
    },
    // 是否显示底部版权
    copyright: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ready: false,
      contentEl: null,
      copyrightEl: null,
      layoutContentEl: null,
      layoutContentMainEl: null
    };
  },
  watch: {
    margin: {
      handler: function handler(val) {
        var _this = this;
        nextTick(function () {
          if (_this.contentEl) {
            if (!val) {
              _this.contentEl.classList.add(noMarginClassName);
            } else {
              _this.contentEl.classList.remove(noMarginClassName);
            }
          }
        });
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.contentEl = document.getElementsByClassName('i-layout-content-main')[0];
    this.copyrightEl = document.getElementsByClassName('i-copyright')[0];
    if (this.copyrightEl && !this.copyright) this.copyrightEl.classList.add(noCopyrightClassName);
    this.layoutContentEl = document.getElementsByClassName('i-layout-content')[0];
    if (this.layoutContentEl) this.layoutContentEl.classList.add(contextFlexClassName);
    this.layoutContentMainEl = document.getElementsByClassName('i-layout-content-main')[0];
    if (this.layoutContentMainEl) this.layoutContentMainEl.classList.add(contextMainFlexClassName);
    nextTick(function () {
      _this2.ready = true;
    });
  },
  beforeUnmount: function beforeUnmount() {
    if (this.contentEl) this.contentEl.classList.remove(noMarginClassName);
    if (this.copyrightEl) this.copyrightEl.classList.remove(noCopyrightClassName);
    if (this.layoutContentEl) this.layoutContentEl.classList.remove(contextFlexClassName);
    if (this.layoutContentMainEl) this.layoutContentMainEl.classList.remove(contextMainFlexClassName);
    this.contentEl = null;
    this.copyrightEl = null;
    this.layoutContentEl = null;
    this.layoutContentMainEl = null;
  }
};